<template>
  <el-dialog :title="$t('i18n.095c626470e645a686fe9cbb813140b0')" :visible.sync="visible" :before-close="handleClose">
    <div class="tax-base-info">
      <ul>
        <li v-for="item in base" :key="item.title">
          <span class="inner-title">{{ $t(item.title) }}：</span>
          <span class="inner-text">{{ item.content }}</span>
        </li>
      </ul>
    </div>
    <div class="tax-explain">
      <ul>
        <li>
          <h4 class="tax-s-title">{{ $t('64ef181b') }}</h4>
          <div class="tax-list">
            <div>
              <span>{{ $t('514') }}：</span>
              <span>（10,000.00-1,000.00）/9 = 1,000.00 THB</span>
            </div>
            <div>
              <span>{{ $t('i18n.5aa58cb69f0f4861ba1b711313064e5c') }}：</span>
              <span>（10,000.00-1,000.00-1,000.00）/8 = 1,000.00 THB</span>
            </div>
          </div>
        </li>
        <li>
          <h4 class="tax-s-title">{{ $t('4ef181bf') }}</h4>
          <div class="tax-list">
            <div class="tax-explain-text">
              <i class="el-icon-warning-outline"></i>
              <span>{{ $t('ef181bf5') }}</span>
            </div>
            <div>
              <span>{{ $t('514') }}：</span>
              <span>（10,000.00-1,000.00）/（19+30*8）*19 = 660.23 THB</span>
            </div>
            <div>
              <span>{{ $t('i18n.5aa58cb69f0f4861ba1b711313064e5c') }}：</span>
              <span>（10,000.00-1,000.00-660.23）/8 = 1,042.47 THB</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="tax-date">
      <img
        src="https://ard-flashhr-tra.oss-ap-southeast-1.aliyuncs.com/file/58b1fc04799f0fafc34096a75afac87f_cd2d9b945f469b1045929b4bed53a5f3.png"
        alt="date"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      base: [
        { title: 'i18n.af0899b2737d45718ad65c983efb0b43', content: '2022.03.16 ~ 2022.04.15' },
        { title: '398', content: '2022.04' },
        { title: '28', content: '2022.03.28' },
        { title: 'i18n.867a6368a19c419ab2997e50f49d1b78', content: '10,000.00 THB' },
        { title: 'i18n.5dd5b55cdcf74ff2af6430496ec1e389', content: '1,000.00 THB' }
      ]
    }
  },
  methods: {
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tax-base-info {
  background: #f7f8fa;
  padding: 12px;
  line-height: 2em;
  color: #262626;
  .inner-title {
    color: #595959;
  }
}
.tax-explain {
  line-height: 2em;
  &-text {
    color: #8c8c8c;
  }
  .el-icon-warning-outline {
    margin-right: 5px;
  }
  color: #262626;
}
.tax-s-title {
  margin: 0;
  margin-top: 10px;
  font-size: 14px;
}
.tax-date {
  margin-top: 8px;
  img {
    width: 100%;
  }
}
</style>
